"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    CarouselSlideNumText: ()=>CarouselSlideNumText
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const Span_cjs_namespaceObject = require("../Text/Span.cjs");
const CarouselSlideNumText = ({ currentSlide, totalSlides, numbersClasses = '', ...props })=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(Span_cjs_namespaceObject.Span, {
        textStyle: "body3",
        palette: "neutral",
        shade: "1",
        className: numbersClasses,
        "data-testid": "carousel-numbers-text",
        ...props,
        children: [
            currentSlide,
            " / ",
            totalSlides
        ]
    });
exports.CarouselSlideNumText = __webpack_exports__.CarouselSlideNumText;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "CarouselSlideNumText"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
